import DOMPurify from 'dompurify'
import { marked } from 'marked'

const defaultAllowTags = [
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'h7',
  'h8',
  'br',
  'b',
  'i',
  'strong',
  'em',
  'a',
  'pre',
  'code',
  'img',
  'tt',
  'div',
  'ins',
  'del',
  'sup',
  'sub',
  'p',
  'ol',
  'ul',
  'table',
  'thead',
  'tbody',
  'tfoot',
  'blockquote',
  'dl',
  'dt',
  'dd',
  'kbd',
  'q',
  'samp',
  'var',
  'hr',
  'ruby',
  'rt',
  'rp',
  'li',
  'tr',
  'td',
  'th',
  's',
  'strike',
  'summary',
  'details',
  'caption',
  'figure',
  'figcaption',
  'abbr',
  'bdo',
  'cite',
  'dfn',
  'mark',
  'small',
  'span',
  'time',
  'wbr',
]

interface IOptions {
  allowedTags?: string[]
  allowedAttr?: string[]
}

export function markdownToHtml(
  value: string = '',
  { allowedTags, allowedAttr }: IOptions = {},
): string {
  return marked(
    DOMPurify.sanitize(value, {
      ALLOWED_TAGS: allowedTags || defaultAllowTags,
      ...(allowedAttr ? { ALLOWED_ATTR: allowedAttr } : {}),
      KEEP_CONTENT: true,
    }),
  )
}

export function sanitizeHtml(
  value: string = '',
  { allowedTags, allowedAttr }: IOptions = {},
): string {
  return DOMPurify.sanitize(value, {
    ALLOWED_TAGS: allowedTags || defaultAllowTags,
    ...(allowedAttr ? { ALLOWED_ATTR: allowedAttr } : {}),
    KEEP_CONTENT: true,
  })
}
